module.exports = __webpack_public_path__ + "img/VPN.4acda400.svg";